import React from "react"
import Grid from "../grid/Grid"

import Twitter from "./../../assets/twitter.svg"
import Github from "./../../assets/github.svg"
import Instagram from "./../../assets/instagram.svg"
import "./footer.css"

export const Footer = () => {
  return (
    <div className="footer">
      <Grid>
        <div className="footer__wrapper">
          <p>&copy; Benjamin Konopka 2020</p>
          <div className="footer__social">
            <a href="https://twitter.com/benschodie" target="blank">
              <Twitter />
            </a>
            <a
              href="https://www.instagram.com/1lifeofanoob/?hl=de"
              target="blank"
            >
              <Instagram />
            </a>
            <a href="https://github.com/Benschodie" target="blank">
              <Github />
            </a>
          </div>
        </div>
      </Grid>
    </div>
  )
}

export default Footer
